import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import VoucherAd from '../components/voucher-ad'
import config from '../../data/siteConfig'

const IndexPage = () => (
  <span>
    <Helmet
      title={config.siteTitle}
      meta={[
        { name: 'description', content: config.siteDescription }
      ]}
    />
    <div className="home banner">
      <div className="banner-info top-off-center text-center">
        <h2 className="uppercase">The Ultimate Off Road Experience</h2>
        <span className="spacer white hide-for-small-only">―</span>
        <h5 className="hide-for-small-only">{config.fullDayPrice} per person for a full day</h5>
        <h5 className="hide-for-small-only">{config.halfDayPrice} per person for a half day</h5>
        <a className="button secondary uppercase large hide-for-small-only" href="/bookings">Bookings</a>
      </div>
    </div>
    <main>
      <section className="row">
        <div className="small-12 medium-10 columns">
          <div className="content-header">
            <h1 className="uppercase">Welcome to {config.siteName}</h1>
          </div>
        </div>
      </section>
      <section className="row">
        <div className="large-9 columns">
          <div className="content-body">
            <h2 className="subheader"><small>"This is real off-roading not a glorified passenger ride in mud."</small></h2>

            <p>Our vehicles are true competition prepared off road trials vehicles. They are based on the Land Rover chassis and all of them have been used in actual competition. Unlike other places, we don't mind if you bash them about a bit or get the seats covered in mud - its what they were built for!</p>
            <p>The course is packed with 90 degree banks, mud pits and slopes with lots of natural obstacles. It has been purpose built by expert off road trials course builders, meaning that this is the closest you will get to full on trials driving without entering an actual competition.</p>

            <p>Dreaming of Dakar &amp; WRC? This is a fantastic foundation for budding off-road racing &amp; rally drivers.</p>
            <p><strong>A half day’s start time is 10am and we finish around 1.30pm.</strong></p>
            <p><strong>A full day’s start time is 10am and we finish around 4.30pm.</strong></p>
            <p>The day starts with a short safety talk, then its over to you.</p>

            <p>This is the most driving you will do on one of these courses - we hear this from our customers! We couldn’t believe that on other days you are driven around. Throughout the day you will alternate with your passenger, believe us you'll be grateful for these breaks!</p>
            <p className="lead"><em>"This is real off-roading not a glorified passenger ride in mud."</em></p>
            <p>For more information, or if you need to talk with someone about our days please call on</p>
            <p>{config.sitePhone} and we will answer all queries.</p>
          </div>
        </div>
        <aside className="large-3 columns">
          <div className="content-body">
            <VoucherAd />
          </div>
        </aside>
      </section>
    </main>
  </span>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js